<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<h2 class="Verse-head" id="_idParaDest-11"><a id="_idTextAnchor011"></a>Blind Interpreter</h2>
<p class="Verse-new">Light-blinded</p>
<p class="Verse-main">in my own blindness</p>
<p class="Verse-main">I take the helm </p>
<p class="Verse-main">of my unbridled</p>
<p class="Verse-main">ship of fools.</p>
<p class="Verse-new">Overladen</p>
<p class="Verse-main">with information</p>
<p class="Verse-main">erotic to the core</p>
<p class="Verse-main">I crash the giant waves</p>
<p class="Verse-main">of catastrophes</p>
<p class="Verse-main">that surround us:</p>
<p class="Verse-new">cities, water-starved </p>
<p class="Verse-main">choked with every</p>
<p class="Verse-main">driven thing, landscapes</p>
<p class="Verse-main">frying in the sun –</p>
<p class="Verse-main">I reach out, sightless,</p>
<p class="Verse-main">pleading for a future.</p>
<p class="Verse-main">Like a slave-trader,</p>
<p class="Verse-main">lowest of the low,</p>
<p class="Verse-main">blinded now with insight</p>
<p class="Verse-main">of a captain prophet,</p>
<p class="Verse-main">I turn my boat around</p>
<p class="Verse-main">join those crying out for freedom:</p>
<p class="Verse-main">all her simplicities</p>
<p class="Verse-last">and amazing grace</p>
<p class="Verse-last">in heartfelt prayer.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781398400801_EPUB-13.vue?305561ff